import api from '../posAPI';


export const getAllUnits = async () => {
    try {
        const response = await api.get('/inventory/list/units');
        if (response.data && Array.isArray(response.data.Data)) {
            return response.data.Data;  
        } else {
            throw new Error("Unexpected response format");
        }
    } catch (error) {
        if (error.response) {
            // You can use a toast or console.log here for user-friendly error reporting
        }
        throw new Error('Failed to fetch users. Please try again.');
    }
};


export const newUnit = async (data) => {
    try {
        const response = await api.post('/inventory/add/unit', data); // Use POST
        console.log("response", response.data);
        return response.data;
    } catch (error) {
        return error.response.data;
    }
};


export const updateUnit = async (data) => {
    try {
        const response = await api.post('/inventory/update/unit', data); // Use POST
        console.log("response", response.data);
        return response.data;
    } catch (error) {
        return error.response.data;
    }
};
